import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var Success = function (props) {
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 2.25C6.61538 2.25 2.25 6.61538 2.25 12C2.25 17.3846 6.61538 21.75 12 21.75C17.3846 21.75 21.75 17.3846 21.75 12C21.75 6.61538 17.3846 2.25 12 2.25ZM10.875 15.75L6.75 11.625L7.5 10.5L10.875 12.75L16.1089 8.25L17.25 9.375L10.875 15.75Z",
    fill: "currentColor"
  }));
};
export { Success as default };
//# sourceMappingURL=Success.js.map
